// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__zSUXs","footer":"footer_footer__llt5b","text":"footer_text__M7EJq"};